module.exports = __webpack_public_path__ + "static/word-help.47078785.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/word-help.png
// module id = 993
// module chunks = 2